import React from 'react';
import './EmojiIcon.css';
import { iconMap } from './IconMap';

const EmojiIcon = ({ emoji, className = '', style = {} }) => {
  // Detecta se está no Windows
  const isWindows = navigator.platform.indexOf('Win') > -1;
  
  // No Windows, sempre usa SVG se disponível
  if (isWindows && iconMap[emoji]) {
    return (
      <span 
        className={`emoji-icon svg-icon ${className}`}
        style={style}
        role="img"
        aria-label={emoji}
        title={emoji}
      >
        {iconMap[emoji]}
      </span>
    );
  }

  // Em outros sistemas ou se não há SVG disponível, usa emoji
  return (
    <span 
      className={`emoji-icon ${className}`}
      style={style}
      role="img"
      aria-label={emoji}
      title={emoji}
    >
      {emoji}
    </span>
  );
};

export default EmojiIcon;